import React from 'react'
import { Slice } from 'gatsby'
import { SliceZone } from '@prismicio/react'

const components = {
  activecampaign_form: ({ slice }) => <Slice alias='ActiveCampaign' slice={slice} />,
  auction: ({ context, slice }) => <Slice alias='Auction' slice={slice} context={context} />,
  auction_calendar: ({ context, slice }) => <Slice alias='AuctionCalendar' slice={slice} />,
  banner_locations: ({ slice }) => <Slice alias='BannerLocation' slice={slice} />,
  banner_with_caption: ({ slice }) => <Slice alias='BannerWithCaption' slice={slice} />,
  card_deck: ({ slice }) => <Slice alias='CardDeck' slice={slice} />,
  company_link: ({ slice }) => <Slice alias='CompanyLink' slice={slice} />,
  contact: ({ slice }) => <Slice alias='Contact' slice={slice} />,
  counter: ({ slice }) => <Slice alias='Counter' slice={slice} />,
  featured_cards: ({ slice }) => <Slice alias='FeaturedCards' slice={slice} />,
  faq: ({ slice }) => <Slice alias='Accordion' slice={slice} />,
  headshots: ({ slice }) => <Slice alias='Headshots' slice={slice} />,
  hero: ({ slice }) => <Slice alias='Hero' slice={slice} />,
  history: ({ slice }) => <Slice alias='History' slice={slice} />,
  hubspot_form: ({ slice }) => <Slice alias='Hubspot' slice={slice} />,
  icon_deck: ({ slice }) => <Slice alias='IconDeck' slice={slice} />,
  image: ({ slice }) => <Slice alias='Image' slice={slice} />,
  image_gallery: ({ slice }) => <Slice alias='ImageGallery' slice={slice} />,
  locations: ({ slice }) => <Slice alias='Locations' slice={slice} />,
  logos: ({ slice }) => <Slice alias='PartnerLogos' slice={slice} />,
  panel: ({ slice }) => <Slice alias='Panel' slice={slice} />,
  private_treaty: ({ slice }) => <Slice alias='PrivateTreaty' slice={slice} />,
  product_list: ({ slice }) => <Slice alias='ProductList' slice={slice} />,
  quote: ({ slice }) => <Slice alias='Quote' slice={slice} />,
  text: ({ slice }) => <Slice alias='Text' slice={slice} />,
  testimonial_gallery: ({ slice }) => <Slice alias='TestimonialGallery' slice={slice} />,
  video: ({ slice }) => <Slice alias='Video' slice={slice} />
}

const SliceList = ({ isLoggedIn, location, showTabs, slices }) => {
  return <SliceZone slices={slices} context={{ location, isLoggedIn, showTabs }} components={components} defaultComponent={() => null} />
}

export default React.memo(SliceList)
